import request from '@/utils/request'

let CodeBatchApi = {
 /*批次列表*/
 batchlist(data) {
  return request._post('/shop/plus.codebatch.codebatch/index', data);
},
 /*批次编码列表*/
 codelist(data) {
  return request._post('/shop/plus.codebatch.code/index', data);
},
/*获取详情*/
getDetail(data) {
  return request._get('/shop/plus.codebatch.codebatch/add', data);
},
/*添加批次*/
addBacth(data) {
  return request._post('/shop/plus.codebatch.codebatch/add', data);
},
/*查询二维码*/
findPosterCode(data) {
  return request._post('/shop/plus.codebatch.code/getPoster', data);
},
/*获取编码批次列表*/
getCodeList(data) {
  return request._post('/shop/plus.codebatch.codebatch/getCodeBatchList', data);
},
/*批量导出编码*/
exportCode(data) {
  return request._post('/shop/plus.codebatch.codebatch/exportCode', data);
},
}
export default CodeBatchApi;



// WEBPACK FOOTER //
// ./src/api/codebatch.js